const ThemeObj = {
  token: {
    colorPrimary: "#1b6ad5",
    fontFamily: "DMSans-Medium",
    borderRadius: 4,
  },
};

export default ThemeObj;
